import axios from "axios";

export default function getKnockOffList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post("/distributor/admin/api/v1/master-list/knock-off-list", {
        length: parameters.length,
        start: parameters.start,
        filter: {
          requestor: parameters.filter.requestors,
          products: parameters.filter.products,
          role: parameters.filter.role,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
